import { render, staticRenderFns } from "./BTableFiles.vue?vue&type=template&id=db582562&"
import script from "./BTableFiles.vue?vue&type=script&lang=js&"
export * from "./BTableFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports